import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 2 }
const _hoisted_4 = { key: 3 }
const _hoisted_5 = { key: 4 }
const _hoisted_6 = { style: {"text-align":"left","width":"100%"} }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_p_card = _resolveComponent("p-card")!
  const _component_p_timeline = _resolveComponent("p-timeline")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[1] || (_cache[1] = _createElementVNode("h3", { class: "m-1" }, [
      _createElementVNode("b", null, "Events")
    ], -1)),
    _cache[2] || (_cache[2] = _createElementVNode("hr", null, null, -1)),
    _createVNode(_component_p_timeline, {
      value: _ctx.events,
      align: "alternate"
    }, {
      marker: _withCtx((slotProps) => [
        _createElementVNode("span", {
          class: "time-event",
          style: _normalizeStyle({ background: _ctx.getBg(slotProps.item) })
        }, [
          _createElementVNode("i", {
            class: _normalizeClass(["pi", _ctx.getIcon(slotProps.item)])
          }, null, 2)
        ], 4)
      ]),
      content: _withCtx((slotProps) => [
        _createVNode(_component_p_card, null, {
          title: _withCtx(() => [
            _createElementVNode("h4", null, _toDisplayString(slotProps.item.input_event ? "Data Update" : "Review") + " Event", 1),
            (slotProps.item.restore)
              ? (_openBlock(), _createElementBlock("small", _hoisted_1, "Restored"))
              : (slotProps.item.approve)
                ? (_openBlock(), _createElementBlock("small", _hoisted_2, "Approved"))
                : (slotProps.item.rejected)
                  ? (_openBlock(), _createElementBlock("small", _hoisted_3, "Rejected"))
                  : (slotProps.item.input_event)
                    ? (_openBlock(), _createElementBlock("small", _hoisted_4, "Edit"))
                    : (_openBlock(), _createElementBlock("small", _hoisted_5, "Need information"))
          ]),
          content: _withCtx(() => [
            _cache[0] || (_cache[0] = _createElementVNode("hr", null, null, -1)),
            _createElementVNode("ul", _hoisted_6, [
              _createElementVNode("li", null, "Username: " + _toDisplayString(slotProps.item.username), 1),
              _createElementVNode("li", null, "Date: " + _toDisplayString((new Date(slotProps.item.date)).toLocaleString("en-IN")), 1),
              (slotProps.item.stage)
                ? (_openBlock(), _createElementBlock("li", _hoisted_7, "Stage: " + _toDisplayString(slotProps.item.stage), 1))
                : _createCommentVNode("", true),
              _createElementVNode("li", null, "Role: " + _toDisplayString(slotProps.item.role), 1),
              (slotProps.item.remarks?.length)
                ? (_openBlock(), _createElementBlock("li", _hoisted_8, " Remarks: " + _toDisplayString(slotProps.item.remarks), 1))
                : _createCommentVNode("", true),
              (slotProps.item.rev_number)
                ? (_openBlock(), _createElementBlock("li", _hoisted_9, " Revision Number: " + _toDisplayString(slotProps.item.rev_number), 1))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 2
        }, 1024)
      ]),
      _: 1
    }, 8, ["value"])
  ], 64))
}